import { createBrowserRouter, Navigate } from 'react-router-dom';
import { lazy, Suspense } from 'react';

import { ScreenLoader, RouterError } from 'components';
import { ROUTES } from 'consts';

import { Dashboard } from './pages/Dashboard';
import { Main } from './pages/Main';
import { Root } from 'Root';

const LazyClassroomUnifiedPlayer = lazy(() => import('./pages/ClassroomUnifiedPlayer'));
const LazyAnonymousExercises = lazy(() => import('./pages/AnonymousExercises'));
const LazyClassroomUnified = lazy(() => import('./pages/ClassroomUnified'));
const LazyClassroomPlayer = lazy(() => import('./pages/ClassroomPlayer'));
const LazyGroupClassroom = lazy(() => import('./pages/GroupClassroom'));
const LazySelectAccount = lazy(() => import('./pages/SelectAccount'));
const LazyClassroom = lazy(() => import('./pages/Classroom'));
const LazyError = lazy(() => import('./components/Error'));
const LazyTeacher = lazy(() => import('./pages/Teacher'));
const LazyStudent = lazy(() => import('./pages/Student'));
const LazyParent = lazy(() => import('./pages/Parent'));
const LazySignIn = lazy(() => import('./pages/SignIn'));
const LazyTutor = lazy(() => import('./pages/Tutor'));

export const router = createBrowserRouter([
  {
    path: '/',
    element: <Root />,
    errorElement: <RouterError />,
    children: [
      {
        path: ROUTES.SELECT_ACCOUNT,
        element: (
          <Suspense fallback={<ScreenLoader />}>
            <LazySelectAccount />
          </Suspense>
        )
      },
      {
        path: `${ROUTES.GROUP_CLASSROOM}/*`,
        element: (
          <Suspense fallback={<ScreenLoader />}>
            <LazyGroupClassroom />
          </Suspense>
        )
      },
      {
        path: `${ROUTES.TEACHER}/*`,
        element: (
          <Suspense fallback={<ScreenLoader />}>
            <LazyTeacher />
          </Suspense>
        )
      },
      {
        path: `${ROUTES.STUDENT}/*`,
        element: (
          <Suspense fallback={<ScreenLoader />}>
            <LazyStudent />
          </Suspense>
        )
      },
      {
        path: `${ROUTES.PARENT}/*`,
        element: (
          <Suspense fallback={<ScreenLoader />}>
            <LazyParent />
          </Suspense>
        ),
      },
      {
        path: `${ROUTES.SIGNIN}/*`,
        element: (
          <Suspense fallback={<ScreenLoader />}>
            <LazySignIn />
          </Suspense>
        ),
      },
      {
        path: ROUTES.ANONYMOUS_EXERCISES,
        element: (
          <Suspense fallback={<ScreenLoader />}>
            <LazyAnonymousExercises />
          </Suspense>
        )
      },
      {
        path: ROUTES.CLASSROOM_PLAYER,
        element: (
          <Suspense fallback={<ScreenLoader />}>
            <LazyClassroomPlayer />
          </Suspense>
        ),
      },
      {
        path: ROUTES.CLASSROOM_UNIFIED_PLAYER,
        element: (
          <Suspense fallback={<ScreenLoader />}>
            <LazyClassroomUnifiedPlayer />
          </Suspense>
        ),
      },
      {
        path: `${ROUTES.NEW_CLASSROOM}/*`,
        element: (
          <Suspense fallback={<ScreenLoader />}>
            <LazyClassroom />
          </Suspense>
        ),
      },
      {
        path: `${ROUTES.CLASSROOM_UNIFIED}/*`,
        element: (
          <Suspense fallback={<ScreenLoader />}>
            <LazyClassroomUnified />
          </Suspense>
        ),
      },
      {
        path: ROUTES.TUTOR,
        element: (
          <Suspense fallback={<ScreenLoader />}>
            <LazyTutor />
          </Suspense>
        ),
      },
      {
        path: 'dashboard',
        element: <Dashboard />
      },
      {
        path: `/classroom/*`,
        element: (
          <Navigate
            to={`${window.location.pathname.replace('classroom', 'new-classroom')}${window.location.search}`}
            replace
          />
        ),
      },
      {
        path: `/view/*`,
        element: (
          <Navigate
            to={`/new-classroom${window.location.pathname}${window.location.search}`}
            replace
          />
        ),
      },
      {
        path: `/restorepassword/*`,
        element: (
          <Navigate
            to={`${window.location.pathname.replace('restorepassword', 'signin/forgot-password')}${window.location.search}`}
            replace
          />
        ),
      },
      {
        path: 'kid-phaser/*',
        element: (
          <Navigate
            to={`${window.location.pathname.replace('kid-phaser', 'student/game-world')}${window.location.search}`}
            replace
          />
        ),
      },
      {
        path: 'pulse/*',
        element: (
          <Navigate
            to={`${window.location.pathname.replace('pulse', 'student/pulse')}${window.location.search}`}
            replace
          />
        ),
      },
      {
        path: 'chooseprofile',
        element: (
          <Navigate
            to={`/select-account${window.location.search}`}
            replace
          />
        ),
      },
      {
        path: 'teacher-new/*',
        element: (
          <Navigate
            to={`/teacher/dashboard${window.location.search}`}
            replace
          />
        ),
      },
      {
        path: 'referrals',
        element: (
          <Navigate
            to={`/parent/referrals${window.location.search}`}
            replace
          />
        ),
      },
      {
        path: '',
        element: <Main />
      },
      {
        path: '*',
        element: (
          <Suspense fallback={<ScreenLoader />}>
            <LazyError type="not-found" />
          </Suspense>
        ),
      },
    ],
  },
]);